import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects';
import { LmFormAction } from './enum';
import { selectLmFormData } from './selector';
import { LmForm } from './interface';
import { getLmPayload } from './util/lmSaga.util';
import {
    Address,
    LmFormDTO,
    LmResponse,
    postLmForm,
} from '@vfde-sails/avc-core';
import { selectAddress } from '../App/selector';
import {
    handleLmResponse,
    handleLmResponseError,
} from './action';
import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { ErrorType } from '../../container/App/enum';
import {
    startLoadingOverlay,
    stopLoadingOverlay,
} from '../Overlay/action';
import {
    trackError,
    trackLMForm,
} from '../../tracking/tracking';
import { LMFormTrackingState } from '../../tracking/enum';

/**
 * Submits LM Form
 */
export function* submitLmFormSaga () {
    const formData: LmForm = yield select(selectLmFormData);
    const address: Address | undefined = yield select(selectAddress);

    try {
        yield put(startLoadingOverlay(LmFormAction.SUBMIT_LM_FORM));

        if (!address) {
            throw new Error('Unexpected error: No address');
        }

        const payload: LmFormDTO = yield call(getLmPayload, formData, address);
        const response: LmResponse = yield call(postLmForm, payload);

        yield call(trackLMForm, LMFormTrackingState.SUBMIT);
        yield put(handleLmResponse(response));
    }
    catch (error: ApiErrorResponseWithCode<LmResponse> | unknown) {
        if (error instanceof ApiErrorResponseWithCode && error.status === 422) {
            yield put(handleLmResponseError({ error, type: ErrorType.LM_VALIDATION_ERROR }));
            yield call(trackError, error as Error, ErrorType.LM_VALIDATION_ERROR);
        }
        else {
            yield put(handleLmResponseError({ error: error as Error, type: ErrorType.ZP_API }));
            yield call(trackError, error as Error, ErrorType.ZP_API);
        }
    }
    finally {
        yield put(stopLoadingOverlay(LmFormAction.SUBMIT_LM_FORM));
    }
}

/**
 * LM Container saga
 */
export default function* saga () {
    yield takeLatest(LmFormAction.SUBMIT_LM_FORM, submitLmFormSaga);
}
